import React, { useEffect } from "react";
import { Drawer } from "antd";
import moment from "moment";

import { useStateValue } from "../../state";
import { isDate } from "../../services/funcoes";
import { MinusOutlined } from "@ant-design/icons";
import { getNavegacao } from "../../services/auth";
import { drawerActions, manutencaoActions } from "../../actions";
import { gravarTela, limparTela } from "../../services/navigation";

export default function DrawerNav({ title, width = '65%', visible, className, form, limparAoEditar = false, fecharDrawer, fecharDrawerExtra, footer, afterVisibleChange, closeIcon, closable = true, destroyOnClose = false, children, extra }) {
    const [{ ui, manutencao, }, dispatch] = useStateValue();

    function minimizarDrawer() {
        let url = window.document.location.href;
        let nomeForm = url.substring(url.lastIndexOf('/'), url.length);
        setTimeout(() => {
            gravarTela(nomeForm, manutencao);
        }, 500);
        dispatch({ type: drawerActions.CHANGE, data: { showDrawer: false, showDrawerExtra: false } });
    };

    useEffect(() => {
        let jsonGeral = JSON.parse(getNavegacao())?.geral;
        let dadosCaminho = {};
        let url = window.document.location.href;
        let nomeForm = url.substring(url.lastIndexOf('/'), url.length);
        if (!!jsonGeral) {
            dadosCaminho = jsonGeral[nomeForm];
        }
        if (!ui.showDrawer || !ui.showDrawerExtra) {
            if (!!dadosCaminho && !!dadosCaminho.dados && (JSON.parse(dadosCaminho.dados).editar || !!!manutencao.dados)) {
                limparTela(nomeForm);
            }
            if (!!fecharDrawerExtra) {
                fecharDrawerExtra();
            }
            if (!!fecharDrawer) {
                fecharDrawer();

            }
        } else if (visible && !!dadosCaminho && !!dadosCaminho.dados && !!!manutencao.dados) {
            let dados = JSON.parse(dadosCaminho.dados);
            for (let key in dados) {
                if (isDate(dados[key])) {
                    dados[key] = moment(dados[key]);
                }
            }
            dispatch({ type: manutencaoActions.CHANGE, data: { dados: dados } });
        }
    }, [ui]);

    return (
        <Drawer
            open={ui.showDrawer || ui.showDrawerExtra}
            destroyOnClose={limparTela}
            title={title}
            width={width}
            onClose={minimizarDrawer}
            footer={footer}
            closeIcon={<MinusOutlined />}
            closable={closable}
            className={className}
            extra={extra}
        >
            {children}
        </Drawer>
    );
};